<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        @click="imprimir"
        :loading="loading"
        class="btn-imprimir"
      >
        <v-icon size="18" color="rgba(255,255,255,0.7)">mdi-printer-outline</v-icon>
      </v-btn>
    </template>
    <span>Imprimir</span>
  </v-tooltip>
</template>

<style scoped>
.btn-imprimir {
  background-color: rgba(255, 255, 255, 0.06) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 8px !important;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.btn-imprimir:hover {
  background-color: rgba(255, 255, 255, 0.12) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
}
</style>

<script>
import { imprimirPedido, imprimirComprobante } from "@/services/comprobante.js";
import AfipFiscalAPI from "@/api/afipfiscal";

export default {
  name: "buttonImprimir",
  props: {
    id: {
      type: Number,
      required: true,
    },
    tipoComprobante: {
      type: String,
      required: true,
    },
    estaFacturado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async imprimir() {
      if (this.tipoComprobante === "PE") {
        imprimirPedido(this.id);
        return;
      }

      if (this.tipoComprobante === "NV") {
        this.loading = true;
        try {
          if (this.estaFacturado) {
            const response = await AfipFiscalAPI.getTicket(this.id);
            const ventana = window.open("", "_blank");
            ventana.document.write(response.data);
            ventana.document.close();
            ventana.print();
          } else {
            await imprimirComprobante(this.id);
          }
        } catch (error) {
          const mensaje =
            error.response?.status === 409
              ? error.response.data?.detail ||
                "El comprobante no tiene CAE asociado."
              : "No se pudo imprimir el ticket.";
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "error",
            text: mensaje,
            icon: "mdi-alert-circle",
            timeout: 4000,
          });
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>
